import { AnchorTargetTypes } from "@rsm-hcd/javascript-core";
import Anchor from "atoms/anchors/anchor";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";

interface DashboardLatestNewsItemProps {
    ariaLabel: string;
    external?: boolean;
    to: string;
    targetType?: AnchorTargetTypes;
    iconType: Icons;
    iconSize?: IconSizes;
    title: string;
}

const CSS_BASE_CLASS = "c-dashboard-latest-news-item";

const DashboardLatestNewsItem: React.FC<DashboardLatestNewsItemProps> = ({
    ariaLabel,
    external = false,
    to,
    targetType = AnchorTargetTypes.Blank,
    iconType,
    iconSize = IconSizes.Medium,
    title,
}) => {
    return (
        <li className={CSS_BASE_CLASS}>
            <Anchor
                ariaLabel={ariaLabel}
                external={external}
                cssClassName={`${CSS_BASE_CLASS}__anchor`}
                to={to}
                target={targetType}>
                <Icon type={iconType} size={iconSize} />
                {title}
            </Anchor>
        </li>
    );
};
export default DashboardLatestNewsItem;
